import React from 'react'
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import { withRouter } from 'react-router-dom'

class PendientesPorRecibir extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: 'facturacion/filter',
        deleteUrl: false,
        deleteField: false,
        modUrl: '/RecibirGuia'
      },
      TableOp.Table(
        "Guias Recibidas",
        [
          { label: "Folio Envio", id: "id" },
          { label: "# de guias", id: "numero_guias" },
          // { label: "Folios de las guias", id: "guias_folios" },
          { label: "Fecha de Enviado", id: "createdAt" },
        ],
        [{ id: "edit", icon: "visibility" }]
      )
    );
    this.table();
  }

  navegarFacturas = () => {
    this.props.history.push(`/EnvioFacturas`)
  }

  render() {
    return (
      <div>
        <this.TableRender />
      </div>
    );
  }
}

export default withRouter(PendientesPorRecibir);
